import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { toast } from "react-toastify";

import * as settingsActions from "store/entities/settingsInfo/action";
import * as rolesActions from "store/entities/settingsInfo/action";

import FormDrawer from 'components/__new/common/form-drawer';
import CustomRoleModal from 'components/__new/common/form/CustomRoleModal';
import ViewRoleModal from "components/__new/common/form/ViewRolePermission";
import { ButtonLoader, Input, SelectInput } from "components/__new/common/form";
import validate from "utils/validate";
import iconPlus from "assets/images/icons/plus-green.svg";
import ModalAlert from 'components/__new/common/ModalAlert';
import useLoginInfo from "hooks/useLoginInfo";
import { REGEX_VALUES } from 'utils/regexValues';




const EditNewMemberModal = (props) => {
const {isOpen, setIsOpen, getAllTeamMembers, data: member, getAllRoles} = props;
const {userInfo} = useLoginInfo()
const {employerId} = userInfo?.company
const dispatch = useDispatch()
const { getRolesLoading, getRoles, getAllMembers,  editTeamMemberLoading, editTeamMember, rolePermission  } = useSelector(state => state.entities.settingsInfo)

const [memberRole, setMemberRole] = useState({})
const [isOpenCustomRole, setIsOpenCustomRole] = useState(false);
const [roleName, setRoleName] = useState('')
const [currentPermission, setCurrentPermission] = useState([])
const [allowViewRoleModal, setAllowViewRoleModal] = useState(false);
const [isCreated, setIsCreated] = useState(false)
const [isOpenModalAlertSuccess , setIsOpenModalAlertSuccess] = useState(false)
const [listParams, setListParams] = useState({page: 1, limit: 20, employerId})
const [isFormValidated, setIsFormValidated] = useState(true);

const getCurrentRolePermission = (id) => {
    dispatch(rolesActions.getRolePermission(id))
    }

const handleViewPermission = (id, name) => {
    getCurrentRolePermission(id)
    setAllowViewRoleModal(true)
    setRoleName(name)
    
}

const checkFormValidation = (data = form, appendKey, appendValue) => {
    let params = {...data};
    if (appendKey){ params = {...params, [appendKey]: appendValue}; }
    const errors = validate(params);
    if (errors){
        setIsFormValidated(false);
    }
    else{
        setIsFormValidated(true);
    }
}

const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    
});


const submitForm = async (e) => {
    e.preventDefault();
    
    // const validateForm = {...form};
    //     delete validateForm["role"];
    
    const errors = validate(form);
    if (errors){
        for (var x in errors) {
            toast.error(errors[x]);
        };
        return;
    }
    else{
        const params = {
            firstName: form.firstName,
            lastName: form.lastName,
            email: form.email,
            role: form.role,
        }

        dispatch(settingsActions.editTeamMember(params, member?.id));
        setIsCreated(true)
    }
}

const currentValues = {
        firstName: member?.firstName || "",
        lastName: member?.lastName || "",
        email: member?.email || "",
        role: member?.roleId || "",
}

useEffect(() => {
    dispatch(settingsActions.getAllRoles(listParams));
    setForm({...currentValues})
}, [member]);

useEffect(() => {
    if(editTeamMember?.error === false && isCreated ){
        getAllTeamMembers()
        setIsOpenModalAlertSuccess(true)
        setIsCreated(false)
        
    }
}, [editTeamMember?.error, isCreated]);

useEffect(() => {
    setCurrentPermission(rolePermission?.data)
}, [rolePermission?.data]);

useEffect(() => {
    checkFormValidation();
}, [form]);



    return (
    <>
    <ModalAlert
                successText={editTeamMember?.message}
                dismissText="Close"
                isOpenModalAlert={isOpenModalAlertSuccess}
                setIsOpenModalAlert={setIsOpenModalAlertSuccess}
            />
    <CustomRoleModal 
                isOpen={isOpenCustomRole}
                setIsOpen={setIsOpenCustomRole}
                getAllRoles={getAllRoles}
            />
    <ViewRoleModal 
                        isOpen={allowViewRoleModal}
                        setIsOpen={setAllowViewRoleModal}
                        data={currentPermission}
                        title={roleName || 'Role'}
                    />
    <FormDrawer display="center" size="4xl" isOpen={isOpen} setIsOpen={setIsOpen}>
            <section className="p-6">
                <FormDrawer.Title
                    title=""
                    showCloseButton={true}
                    close={setIsOpen}
                />
                <form onSubmit={submitForm} >
                    <main className='flex w-full  text-ep-gray-700 scrollable-notification-panel'>
                        <section className="flex-1 bg-white p-2">
                            <div className='-mt-3 mb-6'>
                                <h3 className='text-[#0D0C2B] font-bold text-3xl'>Edit Team Member</h3>
                                <p className='text-ep-gray-600 text-[16px] leading-[18.24px] '>Make changes to this team member</p>
                            </div>
                            <div className=''>
                                <Input
                                    type="text"
                                    name="firstName"
                                    label="First Name"
                                    value={form.firstName}
                                    onChange={(e)=> {
                                        const { value } = e.target;
                                        if (value.length < 3) {
                                            setIsFormValidated(false);
                                        }
                                        setForm({...form, firstName: value})
                                    } }
                                    required={true}
                                    placeholder="Enter first name"
                                />
                                <Input
                                    type="text"
                                    name="lastName"
                                    label="Last Name"
                                    value={form.lastName}
                                    onChange={(e)=>{
                                        const { value } = e.target;
                                        if (value.length < 3) {
                                            setIsFormValidated(false);
                                        }
                                        setForm({...form, lastName: value})
                                    } }
                                    required={true}
                                    placeholder="Enter last name"
                                />
                                <Input
                                    type="email"
                                    name="email"
                                    label="Email Address"
                                    value={form.email}
                                    onChange={(e)=> {
                                        const { value } = e.target;
                                        if (!REGEX_VALUES.EMAIL.test(value)) {
                                            setIsFormValidated(false);
                                        }
                                        setForm({...form, email: value});
                                    }}
                                    required={true}
                                    placeholder="Enter email"
                                />
                                <div className='relative'>
                                    <div className='absolute top-0 right-0 '>
                                        <button type='button' onClick={() => setIsOpenCustomRole(true)} className="text-ep-primary text-sm font-medium">
                                            <img src={iconPlus} alt="iconPlus" className="text-ep-primary mr-2 inline-block" />
                                            Create Custom Role
                                        </button>
                                    </div>
                                {/* {(getRolesLoading === true) && 
                                    <Input type="text" label="Role" required={true} value="Loading roles..." disabled={true} />
                                }
                                {(getRolesLoading === false) && 
                                    <SelectInput label="Role" name="role" required={true} value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}>
                                        <option value="">Select a role</option>
                                        {initialRoles?.map(roles => (
                                            <option key={roles.id} value={roles.role?.name}>{roles.role?.name}</option>
                                        ))}
                                    </SelectInput>
                                    } */}
                                {(getRolesLoading === false) && 
                                    <SelectInput label="Role" name="role" required={true} value={form.role} onChange={(e) => setForm({...form, role: e.target.value})}>
                                        <option value="">Select a role</option>
                                        {getRoles?.data?.data?.filter(role => role?.name?.toLowerCase() !== "owner")?.map(role => (
                                            <option key={role.id} value={role.id}>{role.name}</option>
                                        ))}
                                    </SelectInput>
                                    }
                                </div>
                            </div>
                        </section>
                        <section className="flex-1 overflow-y-auto">
                            <h2 className='text-[#0D0C2B]  font-bold text-2xl'>Role Descriptions</h2>
                            <div className="rounded p-2 mt-2 bg-ep-primary-light-100">
                                {(getRolesLoading === false) && 
                                <div>
                                    <div>
                                    {/* {initialRoles?.map((roles) => (
                                        <div key={roles.id} value={roles.role?.name} className='pb-6 border-b px-4 '>
                                            <h3 className='text-[#101828] pt-6 font-bold text-[16px] leading-[19.2px] '>{roles.role?.name}</h3>
                                            <p className='text-ep-gray-600 text-[14px] leading-[18.2px] py-2'>{roles.role?.description}</p>
                                            <button className='text-ep-primary underline font-medium' type="button" onClick={() => viewMemberPermission(roles.role)}>View Permissions</button>
                                        </div>
                                    ))} */}
                                </div>
                                    {getRoles?.data?.data?.filter(role => role?.name?.toLowerCase() !== "owner")?.map(role => (
                                        <div key={role.id} value={role.id} className='pb-6 border-b px-4 '>
                                            <h3 className='text-[#101828] pt-6 font-bold text-[16px] leading-[19.2px] '>{role.name}</h3>
                                            <p className='text-ep-gray-600 text-[14px] leading-[18.2px] py-2'>{role.description}</p>
                                            <button className='text-ep-primary underline font-medium' onClick={() => handleViewPermission(role?.id, role?.name) } type="button">View Permissions</button>
                                        </div>
                                    ))}
                                </div>
                                }
                                
                            </div>
                        </section>
                        
                    </main>
                    <hr />
                    <footer className="p-1 mt-4 flex justify-end space-x-3">
                        <div className='flex'>
                            <div className='pr-5'>
                                <button onClick={setIsOpen} type="button" className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-ep-primary-600 bg-white"                    >
                                    Cancel
                                </button>
                            </div>
                            <div>
                                <ButtonLoader type="submit" loading={editTeamMemberLoading} disabled={!isFormValidated || !form.role} className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                                    Save Changes
                                </ButtonLoader>
                            </div>
                        </div>
                    </footer>    
                </form>
            </section>
        </FormDrawer>
    </>
  )
}

export default EditNewMemberModal
